// extracted by mini-css-extract-plugin
export default {"divider":"LineDivider_divider__ThvQV"};